import { styled as muiStyled } from "@mui/system";
import { TextareaAutosize as BaseTextareaAutosize } from "@mui/material";
import styled from "@emotion/styled";
import { HHNTheme } from "hhn-commons";
import theme from "../../../../../theme";

export const TextareaAutosize = muiStyled(BaseTextareaAutosize)`
    resize: vertical;
    min-height: 30px;
    width: 100%;
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: "2em 0";
    border-radius: 8px;
    color: rgba(0, 0, 0, 0.87);
    background: ${theme.palette.mode === "dark" ? HHNTheme.background : "#fff"};
    border: 1px solid ${
      theme.palette.mode === "dark"
        ? theme.palette.grey[700]
        : theme.palette.grey[200]
    };
    box-shadow: 0px 2px 2px ${
      theme.palette.mode === "dark"
        ? theme.palette.grey[900]
        : theme.palette.grey[50]
    };

    &:hover {
      border-color: ${theme.palette.primary.light};
    }

    &:focus {
      border-color: ${theme.palette.primary.light};
      box-shadow: 0 0 0 1px ${
        theme.palette.mode === "dark"
          ? theme.palette.primary.light
          : theme.palette.primary.light
      };
    }

    // firefox
    &:focus-visible {
      outline: 0;
    }
  `;

export const KnowMeDivWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
`;

export const KnowMeItemDivWrapper = styled.div`
  flex: 1;
`;
